import UserWithAccessRights from "./UserWithAccessRights";
import BillingType from "./BillingType";
import customerStore from "./CustomerStore";
import projectStore from "./ProjectStore";
import billingTypeStore from "./BillingTypeStore";
import userStore from "./userStore";
import userGroupStore from "./userGroupStore";
import timeZoneGroupStore from "./timeZoneGroupStore";
import Group from "./Group";
import {nameComparator} from '../atUtils'
import {customerFromRpc, projectFromRpc} from '../taskManagement/utils'

export function mergeCustomersProjectsFromRPC(customers, projects, newCustomersFirst) {
    // sort data before insert into store
    const sortedCustomers = customers.map(customerFromRpc).sort(nameComparator);
    const sortedProjects = projects.map(projectFromRpc).sort(nameComparator);

    if (newCustomersFirst) {
        customerStore.addManyFirst(sortedCustomers);
    } else {
        customerStore.mergeAll(sortedCustomers);
    }

    projectStore.mergeAll(sortedProjects);
}

export function mergeCustomersProjectsFromJSP(data) {
    // sort data before insert into store
    customerStore.mergeAll(data["customers"].map(customerFromRpc).sort(nameComparator));
    projectStore.mergeAll(data["projects"].map(projectFromRpc).sort(nameComparator));
}

export function replaceTypesOfWorkFromRPC(typesOfWork) {
    billingTypeStore.replaceAll(typesOfWork.map(BillingType.fromRPC));
}

export function replaceUsersFromJSP(data) {
    userStore.replaceAll(data.map(UserWithAccessRights.fromRPC));
}

export function replaceUserGroupsFromJSP(data) {
    userGroupStore.replaceAll(data.map(d => new Group(d["id"], d["name"])))
}

export function replaceTimeZoneGroupsFromJSP(data) {
    timeZoneGroupStore.replaceAll(data.map(d => new Group(d["id"], d["name"])))
}


// WEBPACK FOOTER //
// ./web/js/store/StoreUtils.js